/**
 * @generated SignedSource<<0061a03999cd99c1e2c9751bf98e115a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView$data = {
  readonly isLinkEditable: boolean | null | undefined;
  readonly project: {
    readonly atlasProjectKey: string | null | undefined;
    readonly atlasProjectName: string | null | undefined;
    readonly id: string;
    readonly privateProject: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView";
};
export type atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView$key = {
  readonly " $data"?: atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "atlasProject_issueFieldAtlasProjectReadviewFull_AtlasProjectReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isLinkEditable"
    },
    {
      "concreteType": "JiraTownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "project.id"
        },
        {
          "alias": "atlasProjectKey",
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "alias": "atlasProjectName",
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "privateProject"
        }
      ]
    }
  ],
  "type": "JiraTownsquareProjectField"
};

(node as any).hash = "8cf470fce24aeddf9ae0b7a30fcb0ae1";

export default node;
